export const SELECTED_CAMERA = 'camera/SELECTED_CAMERA'
export const SET_SCREEN_POW = 'camera/SET_SCREEN_POW'
export const SET_SCREEN_PAGE = 'camera/SET_SCREEN_PAGE'
